import { ReactNode, useState } from 'react';

import { ColumnsVisibilityContext } from './context.ts';

import {
    TColumnsVisibilityContextType,
    TProviderProps,
} from '@/contexts/column-visibility/types.ts';

export function ColumnsVisibilityProvider<T>({
    children,
    columns,
    requiredColumnsKeys,
    storageKey,
}: TProviderProps<T>): ReactNode {
    let initialVisible = columns.map((column) => column.key);
    const STORAGE_KEY = `${storageKey}__visible-columns`;
    const storedItems = localStorage.getItem(STORAGE_KEY);

    if (storedItems) {
        const parsedItems = JSON.parse(storedItems);
        if (Array.isArray(parsedItems)) {
            initialVisible = parsedItems;
        } else {
            initialVisible = columns.map((column) => column.key);
        }
    }

    const [visibleKeys, setVisibleKeys] = useState(initialVisible);
    const visibleColumns = columns.filter((column) => visibleKeys.includes(column.key));
    const Context =
        ColumnsVisibilityContext as React.Context<TColumnsVisibilityContextType<T> | null>;

    return (
        <Context.Provider
            value={{
                visibleKeys,
                setVisibleKeys,
                allColumns: columns,
                visibleColumns,
                requiredColumnsKeys,
                storageKey: STORAGE_KEY,
            }}
        >
            {children}
        </Context.Provider>
    );
}
